enum OperatingSystem {
  'Windows' = 'WINDOWS',
  'Apple' = 'APPLE',
  'Linux' = 'LINUX',
  'MagicInfo' = 'MAGICINFO',
}

export default OperatingSystem;
